import { api_json } from './api'
import { is_auth_cache_fresh } from './api-failure'

export type AuthUser = {
  id: string | number
  email: string
  name?: string | null
  role: string
  group_id?: number | null
  must_change_password?: boolean
  acl_tags?: string[]
}

const AUTH_STATE = {
  user: null as AuthUser | null,
  checked_at: 0
}

/**
 * O cache de sessão NUNCA expirava: bastava `checked_at > 0`. Tirar a permissão
 * de alguém não tinha efeito na aba aberta — a UI seguia mostrando menus e
 * botões que o backend já negava, e o usuário só descobria pelo 403. O cache de
 * ACL do backend já tem TTL de 60 s; aqui passa a ter o mesmo.
 */
const AUTH_TTL_MS = 60_000

export async function refresh_auth(force = false): Promise<AuthUser | null> {
  if (!force && is_auth_cache_fresh(AUTH_STATE.checked_at, Date.now(), AUTH_TTL_MS)) return AUTH_STATE.user
  const data = await api_json<{ user: AuthUser | null }>('/api/auth/me')
  AUTH_STATE.user = data.user
  AUTH_STATE.checked_at = Date.now()
  return AUTH_STATE.user
}

export function clear_auth_cache(): void {
  AUTH_STATE.user = null
  AUTH_STATE.checked_at = 0
}

export function get_cached_auth_user(): AuthUser | null {
  return AUTH_STATE.user
}

export function has_any_acl(user: AuthUser | null | undefined, required: string[]): boolean {
  if (!required.length) return true
  if (!user) return false
  const tags = Array.isArray(user.acl_tags) ? user.acl_tags : []
  if (tags.includes('*')) return true
  return required.some(tag => tags.includes(tag))
}

export function has_acl(user: AuthUser | null | undefined, ...required: string[]): boolean {
  return has_any_acl(user, required)
}

export function preferred_entry_path(user: AuthUser | null | undefined): string {
  if (user?.must_change_password) return '/conta?must-change=1'
  if (has_acl(user, 'ads:list', 'ads:moderate', 'users:list', 'users:manage', 'acl:manage', 'pricing:manage', 'categories:manage', 'contacts:read')) return '/adm'
  return '/conta'
}
